export default __webpack_public_path__ + "static/customer4-2943ccd39efd0c80e6890c4eb5d59900.jpg";